import {
  SEARCH_EXPANDED_QUERY_CACHE_STORE_NAME,
  USER_DOCUMENT_SEARCH_EXPANDED_QUERY_CACHE_STORE_NAME,
} from '@/constants';
import axios from 'axios';
import Qs from 'qs';
import { AdpDocument, DocType } from '@/types';
import { searchExpandedQueryCache } from '@/utils/searchExpandedQueryCache';

export async function fetchDocument(
  articleId: number,
  docType: DocType,
): Promise<AdpDocument> {
  const { data } = await axios.get<AdpDocument>(`/${docType}s/${articleId}`);
  return data;
}

export async function getDocumentsCount(
  query: string,
  url: string,
  storeName:
    | typeof USER_DOCUMENT_SEARCH_EXPANDED_QUERY_CACHE_STORE_NAME
    | typeof SEARCH_EXPANDED_QUERY_CACHE_STORE_NAME,
  docTypes?: DocType[],
): Promise<number> {
  const params = {
    query: query,
    doc_types: docTypes,
    cached_expanded_queries: null as string[] | null,
  };

  const expandedQueryCache = query
    ? await searchExpandedQueryCache.getCache(query, storeName)
    : null;
  if (expandedQueryCache) {
    params.cached_expanded_queries = expandedQueryCache;
  }

  const fullUrl = `${url}?${Qs.stringify(params, {
    arrayFormat: 'brackets',
  })}`;
  const data = (
    await axios.get<{ count: number; expanded_queries: string[] }>(fullUrl)
  ).data;

  if (
    !expandedQueryCache &&
    query &&
    data.expanded_queries &&
    data.expanded_queries.length > 0
  ) {
    searchExpandedQueryCache.setCache(query, data.expanded_queries, storeName);
  }
  return data.count;
}

export function patentPublicationOffice(
  adpDocument?: AdpDocument,
): string | undefined {
  return adpDocument?.doc_type === 'patent'
    ? adpDocument.publication_office
    : undefined;
}

export function reportPageNumber(
  adpDocument?: AdpDocument,
): number | undefined {
  return adpDocument?.doc_type === 'report'
    ? adpDocument.page_number
    : undefined;
}

export function buildAdpDocumentParams(adpDocument?: AdpDocument) {
  return {
    article_id: adpDocument?.id,
    doc_type: adpDocument?.doc_type,
    lang: adpDocument?.lang,
    patent_publication_office: patentPublicationOffice(adpDocument),
    report_page_number: reportPageNumber(adpDocument),
  };
}

export function buildArticleTagMemoParams(adpDocument: AdpDocument) {
  return {
    doc_type: adpDocument.doc_type,
    article_lang: adpDocument.lang,
    patent_publication_office: patentPublicationOffice(adpDocument),
    report_page_number: reportPageNumber(adpDocument),
  };
}
